import { createReducer } from 'redux-create-reducer'
import type { RootGroup } from 'types/shareable-channel'
import type { loadRootGroup, loadRootGroupZipUrls } from './actions'
import * as types from './types'

export const rootGroupReducer = createReducer<RootGroup | null, any>(null, {
  [types.LOAD_ROOT_GROUP](_, { rootGroup }: ReturnType<typeof loadRootGroup>) {
    return rootGroup
  },

  [types.LOAD_ROOT_GROUP_ZIP_URLS](
    state,
    { zipUrls }: ReturnType<typeof loadRootGroupZipUrls>,
  ) {
    if (!state) return state
    return { ...state, zip_urls: zipUrls }
  },
})
